import type { BulkUpdateWorkOrderMutation } from '#/graphql/types';
import { bulkUpdateWorkOrder } from '#/graphql/mutations';
import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';

const q = gql(bulkUpdateWorkOrder);

type Response = {
  updatedCount?: number | null;
  status?: number | null;
  errors?: Array<string | null> | null;
};

const useWorkOrderBulkUpdate = () => {
  const [mutation, result] = useMutation<BulkUpdateWorkOrderMutation>(q);

  const bulkUpdateWorkOrder = useCallback(
    async (data: {
      values: any;
      ids?: string[];
      params?: any;
      requirements?: any;
    }): Promise<Response | null | undefined> => {
      const { values, ids, params, requirements } = data;

      const response = await mutation({
        variables: {
          data: {
            values: values ? JSON.stringify(values) : null,
            ids,
            params,
            requirements: requirements ? JSON.stringify(requirements) : null,
          },
        },
      });

      return response.data?.bulkUpdateWorkOrder || undefined;
    },
    [mutation],
  );

  return { bulkUpdateWorkOrder, result };
};

export default useWorkOrderBulkUpdate;
